// extracted by mini-css-extract-plugin
export default {"PatientInfo":"styles_PatientInfo__mTkJ5"};